import React from 'react';
type IconProps = {
  className?: string;
  strokeWidth?: number;
};
const base = (className = 'w-7 h-7', strokeWidth = 1.5) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 48 48',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  className
});
// 1. Back — silhouette of a person from behind with spine
export const BackIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-337" data-mp="dxga0m87dvle">
    <circle cx="24" cy="11" r="5" data-id="element-338" data-mp="91iuuj8oeva7" />
    <path d="M14 38c0-8 4-14 10-14s10 6 10 14" data-id="element-339" data-mp="92kh7jv57478" />
    <path d="M24 21v17" data-id="element-340" data-mp="msnx7t3fi1o8" />
    <path d="M21 27h6M21 32h6" data-id="element-341" data-mp="mt5zp7gopc4l" />
  </svg>;
// 2. Abdomen — torso with abs lines
export const AbdomenIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-342" data-mp="3qh7qtf3linx3">
    <path d="M16 10c0 6 0 12 2 18s4 10 6 10 4-4 6-10 2-12 2-18" data-id="element-343" data-mp="3qg642dd7wczj" />
    <path d="M24 14v22" data-id="element-344" data-mp="3mfvxayhlpijm" />
    <path d="M19 19h10M18 25h12M19 31h10" data-id="element-345" data-mp="3mgfdoarlryvj" />
  </svg>;
// 3. Flanks — hourglass / waistline curves
export const FlanksIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-346" data-mp="1gp7uvtuq6qum">
    <path d="M14 8c0 6 6 10 6 16s-6 10-6 16" data-id="element-347" data-mp="1gnwt1zkubt65" />
    <path d="M34 8c0 6-6 10-6 16s6 10 6 16" data-id="element-348" data-mp="1gmv7v2a41qap" />
    <path d="M18 24h12" data-id="element-349" data-mp="1lgzd9h3q9q9o" />
  </svg>;
// 4. Legs — two leg silhouettes
export const LegsIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-350" data-mp="1qh3td60q4izd">
    <path d="M16 8c0 6-1 12-2 20s-2 12-2 14" data-id="element-351" data-mp="srsi8s3hfit6" />
    <path d="M32 8c0 6 1 12 2 20s2 12 2 14" data-id="element-352" data-mp="st3hqfpwa4eh" />
    <path d="M16 8h16" data-id="element-353" data-mp="xptw8ym1wrxs" />
    <path d="M10 42h6M32 42h6" data-id="element-354" data-mp="xrev30feex1g" />
  </svg>;
// 5. Glutes — rounded shape
export const GlutesIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-355" data-mp="12rt34ih026zh">
    <path d="M10 16c0-4 4-8 8-8 3 0 5 2 6 4 1-2 3-4 6-4 4 0 8 4 8 8 0 8-4 24-14 24S10 24 10 16z" data-id="element-356" data-mp="17ot6glmgsvmw" />
    <path d="M24 12v28" data-id="element-357" data-mp="2e5eortnnhqg9" />
  </svg>;
// 6. Chin — profile face showing jawline
export const ChinIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-358" data-mp="2j5szxkkjtgii">
    <path d="M16 10c0-1 1-2 2-2h6c4 0 8 4 8 9v6c0 2-1 4-2 5-1 1-1 2-1 3v3c0 3-3 5-6 5h-3c-2 0-4-1-4-3" data-id="element-359" data-mp="j0xf9offeid4" />
    <circle cx="26" cy="22" r="1" fill="currentColor" data-id="element-360" data-mp="e35f674mnpxu" />
    <path d="M22 28c2 1 4 1 6 0" data-id="element-361" data-mp="e4q9pwqxz8vp" />
  </svg>;
// 7. Arms — bicep flexed arm
export const ArmsIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-362" data-mp="o0a58i1lg5jx">
    <path d="M8 28c4-2 8-2 12 0s7 6 7 12" data-id="element-363" data-mp="o1bimt63144t" />
    <path d="M14 22c2-4 6-8 12-8 7 0 12 4 12 10 0 4-3 8-7 8" data-id="element-364" data-mp="afqtw1mm8xk" />
    <path d="M22 18c2 0 4 2 4 4" data-id="element-365" data-mp="8uz0e6p543e" />
  </svg>;
// 8. Chest — chest outline
export const ChestIcon = ({
  className,
  strokeWidth
}: IconProps) => <svg {...base(className, strokeWidth)} data-id="element-366" data-mp="93j1jwkw07oi">
    <path d="M10 14c0-2 2-4 4-4h20c2 0 4 2 4 4 0 6-2 12-6 14-2 1-4 3-4 6 0 2-2 4-4 4s-4-2-4-4c0-3-2-5-4-6-4-2-6-8-6-14z" data-id="element-367" data-mp="94key7pdl69e" />
    <circle cx="18" cy="22" r="1.5" data-id="element-368" data-mp="4apzxhkptfgn" />
    <circle cx="30" cy="22" r="1.5" data-id="element-369" data-mp="3crkp5u8lb1c9" />
  </svg>;
export const bodyIconMap: Record<string, React.FC<IconProps>> = {
  back: BackIcon,
  abdomen: AbdomenIcon,
  flanks: FlanksIcon,
  legs: LegsIcon,
  glutes: GlutesIcon,
  chin: ChinIcon,
  arms: ArmsIcon,
  chest: ChestIcon
};